import {ModalComponent} from './modal/modal.component';

export class ModalService {

  modalComponent: ModalComponent;

}
